import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack, MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { web_url } from "../../constant";

function ResearcherPenpalMatchingManual() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [openAlert, setOpenAlert] = useState(false);

    const handleClickOpenAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [studentList, setStudentList] = useState([])

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t255'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.setItem("refresh", `${Date.now()}`);
        setOpenError(false);
    };

    //get students
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        setStudentsSelecte([]);
        setPenPalSelected([]);
        setIsControlSelected(null);
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading(true);

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/students/without-penpals`

            axios.get(apiUrl, configToken)
                .then((response) => {
                    try {
                        // console.log("s retreived");
                        const filteredList = response.data.filter(student => student.accountStatus === "ACTIVE")
                        // console.log("s retreived", filteredList);
                        setStudentList(filteredList)
                    } catch {
                        // console.log("s not retreived");
                        setStudentList([]);
                    }

                    setIsLoading(false);
                })
                .catch((err) => {
                    console.log("error occured", err);
                    setIsLoading(false);
                });
        }
    }, [localStorage.getItem("refresh")])

    const [isControlSelected, setIsControlSelected] = useState(null);

    const [penpalSelected, setPenPalSelected] = useState([])

    const [errorNow, setErrorNow] = useState(false)
    const [errorGrp, setErrorGrp] = useState(false)

    const handleClick = () => {
        if (isControlSelected === null) {
            setErrorGrp(true);
            return;
        }

        if (penpalSelected.length !== 2) {
            setErrorNow(true);
            return;
        }
        setErrorNow(false);
        setErrorGrp(false);
        setIsLoading(true);
        const formData = new FormData();
        const typeStudent = isControlSelected ? "CONTROL" : "TREATMENT";
        formData.append('studentEmail', penpalSelected[0]);
        formData.append('penpalEmail', penpalSelected[1]);
        formData.append('penpalGroup', typeStudent);

        console.log("formData", formData);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        axios.put(`${web_url}/api/auth/students/update-penpal`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Authorization": `Bearer ${logDetails.token}`
            },
        }
        ).then((response) => {
            setIsLoading(false);
            localStorage.setItem("refresh", `${Date.now()}`);
        }).catch((err) => {
            console.error('Error:', err);
            if (err.response.data.message) {
                handleClickOpenError(err.response.data.message)
            } else {
                handleClickOpenError("error occured")
            }
            setIsLoading(false);
        });
    }

    const handleClickNext = (listStudent) => {

        if (penpalSelected.length !== 2) {
            setErrorNow(true);
            return;
        }
        setErrorNow(false);
        setErrorGrp(false);

        localStorage.setItem('studentSelected', JSON.stringify(listStudent));

        navigate('/researcher/penpalmatching/confirm')

    };


    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        setOpenInfo(true);
    };

    const handleCloseInfo = () => {
        setOpenInfo(false);
        fileInputRef.current.click();
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (file) {
            // console.log("Selected file:", file.name);
            // You can now upload the file or process it
            setIsLoading(true);
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${logDetails.token}`
                },
            }
            const formData = new FormData();
            formData.append("file", file);
            formData.append("senderEmail", logDetails.email);
            axios.put(`${web_url}/api/auth/students/upload-penpal-matching`, formData, config).then((response) => {
                setIsLoading(false)
                if (response.data.message.includes('Some errors occurred')) {
                    handleClickOpenAlert();
                    // alert("The format is invalid. First column should be student email, the second column should be penpal's email and the third column should be the group(either CONTROL or TREATMENT).Sheet shouldn't have column names.")
                } else {
                    handleClickOpen1();
                }
            }).catch((err) => {
                setIsLoading(false)
                // console.log("err upload",err);
                if (err.response.data.message) {
                    handleClickOpenError(err.response.data.message)
                } else {
                    handleClickOpenError("error occured")
                }

            })
        }
    };

    const [searchInput, setSearchInput] = useState("");

    // const users = [
    //     { userEmail: "saman001@example.com", userFullName: "Saman Perera", ethnicity: "Sinhala" },
    //     { userEmail: "kumar001@example.com", userFullName: "Kumar Raj", ethnicity: "Tamil" },
    //     { userEmail: "nimal002@example.com", userFullName: "Nimal Silva", ethnicity: "Sinhala" },
    //     { userEmail: "anitha002@example.com", userFullName: "Anitha Selvam", ethnicity: "Tamil" },
    //     { userEmail: "kasun003@example.com", userFullName: "Kasun Fernando", ethnicity: "Sinhala" },
    //     { userEmail: "deepa003@example.com", userFullName: "Deepa Ravindran", ethnicity: "Tamil" },
    //     { userEmail: "sunil004@example.com", userFullName: "Sunil Jayasuriya", ethnicity: "Sinhala" },
    //     { userEmail: "mohan004@example.com", userFullName: "Mohan Krishnan", ethnicity: "Tamil" },
    //     { userEmail: "ravi005@example.com", userFullName: "Ravi Alwis", ethnicity: "Sinhala" },
    //     { userEmail: "lakshmi005@example.com", userFullName: "Lakshmi Nadarajah", ethnicity: "Tamil" },
    //     { userEmail: "dilan006@example.com", userFullName: "Dilan Abeysekara", ethnicity: "Sinhala" },
    //     { userEmail: "seetha006@example.com", userFullName: "Seetha Arul", ethnicity: "Tamil" },
    //     { userEmail: "gayan007@example.com", userFullName: "Gayan Dissanayake", ethnicity: "Sinhala" },
    //     { userEmail: "vijay007@example.com", userFullName: "Vijay Suresh", ethnicity: "Tamil" },
    //     { userEmail: "tharindu008@example.com", userFullName: "Tharindu Karunaratne", ethnicity: "Sinhala" },
    //     { userEmail: "rekha008@example.com", userFullName: "Rekha Chandran", ethnicity: "Tamil" },
    //     { userEmail: "sameera009@example.com", userFullName: "Sameera Gunawardena", ethnicity: "Sinhala" },
    //     { userEmail: "nithya009@example.com", userFullName: "Nithya Ramesh", ethnicity: "Tamil" },
    //     { userEmail: "chamara010@example.com", userFullName: "Chamara Weerasinghe", ethnicity: "Sinhala" },
    //     { userEmail: "arjun010@example.com", userFullName: "Arjun Tharmalingam", ethnicity: "Tamil" }
    // ];

    const filteredStudents = studentList.filter((student) =>
        (student.userFullName + " " + student.userEmail).toLowerCase().includes(searchInput.toLowerCase())
    );

    // const filteredStudents = users.filter((student) =>
    //     (student.userFullName + " " + student.userEmail).toLowerCase().includes(searchInput.toLowerCase())
    // );

    const [openInfo, setOpenInfo] = useState(false);

    const [studentsselected, setStudentsSelecte] = useState([]);

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")}  w-screen xl:pt-[20px]`}>
            {
                isLoading ?
                    <div className="items-center justify-center flex pt-[100px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                    :
                    <div>
                        <div className="pb-[120px] xl:hidden">
                            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]`}>
                                <div className="flex items-center justify-start mt-[20px] md:ml-[70px]">
                                    <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                        navigate('/mobile/researcher/dashboard')
                                    }} />
                                    <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                        navigate('/mobile/researcher/dashboard')
                                    }} />
                                    <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                                        navigate('/desktop/researcher/dashboard')
                                    }} />
                                    <p className={`font-bold ml-[10px] ${i18n.language === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{t('t193')}</p>
                                    {/* <MdInfoOutline className="ml-[10px] text-[#1E2533] cursor-pointer text-[20px] md:text-[27px] lg:text-[32px]" /> */}
                                </div>
                                <div className="md:ml-[70px]">
                                    <p className={`text-start font-bold ml-[10px] text-[#1E2533] mt-[10px] ${i18n.language === "en" ? "text-[19px] md:text-[24px] lg:text-[28px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[17px] md:text-[20px] lg:text-[23px] xl:text-[22px] 2xl:text-[18px]" : "text-[16px] md:text-[21px] lg:text-[22px] xl:text-[20px] 2xl:text-[18px]")}`}>
                                        {t('t458')}
                                    </p>
                                    <p className={`text-start font-[500] ml-[10px] text-[#4B5563] mt-[5px] ${i18n.language === "en" ? "text-[15px] md:text-[20px] lg:text-[23px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[12px] md:text-[16px] lg:text-[18px] xl:text-[22px] 2xl:text-[18px]" : "text-[11px] md:text-[15px] lg:text-[18px] xl:text-[20px] 2xl:text-[18px]")}`}>
                                        {t('t460')}
                                    </p>
                                </div>
                            </div>

                            <div className="xl:hidden flex w-full justify-center items-center">
                                <div className="flex w-full md:w-[600px] lg:w-[700px] items-center justify-center">
                                    <div className="xl:hidden grid grid-cols-6 w-full px-[35px] md:px-[20px] gap-[10px] mt-[20px]">
                                        <div className={` col-span-4  ${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} `}>
                                            <input
                                                type="search"
                                                placeholder={t('t256')}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                value={searchInput}
                                                className={`p-2  border border-gray-300 rounded-md w-full text-black ${i18n.language === "en" ? "text-[13px] md:text-[19px] lg:text-[22px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[10px] md:text-[16px] lg:text-[20px] xl:text-[13px] 2xl:text-[18px]" : "text-[9px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")}`}
                                            />
                                        </div>
                                        <div className="col-span-2 flex w-full">
                                            <button onClick={handleButtonClick} className={`w-full bg-[#F2AC0E] text-black font-[600]  rounded-md ${i18n.language === "en" ? "text-[13px] md:text-[19px] lg:text-[22px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[10px] md:text-[16px] lg:text-[20px] xl:text-[13px] 2xl:text-[18px]" : "text-[9px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")}`}>
                                                {t('t282')}
                                            </button>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                accept=".xlsx"
                                                onChange={handleFileChange}
                                                style={{ display: "none" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-[20px]  px-[20px] md:px-[120px] lg:px-[160px] xl:px-[90px] ">

                                {
                                    filteredStudents.length > 0 ?
                                        <>

                                            <div className="max-h-[42vh] xl:max-h-[270px] 2xl:max-h-[550px] overflow-y-auto px-4 xl:grid grid-cols-3 xl:gap-[20px]">
                                                {
                                                    filteredStudents.map((student, index) => {
                                                        const isSelected = penpalSelected.includes(student.userEmail);
                                                        return (
                                                            <div key={index} className="flex justify-center items-center gap-[5px] md:gap-[20px]">
                                                                {
                                                                    penpalSelected.includes(student.userEmail) && <MdCheckBox size={25} className={`xl:hidden text-[#EFAE03]`} onClick={() => {
                                                                        if (!isSelected) {
                                                                            if (penpalSelected.length < 2) {
                                                                                setPenPalSelected([...penpalSelected, student.userEmail])
                                                                                setStudentsSelecte([...studentsselected, student])
                                                                            } else {
                                                                                handleClickOpen();
                                                                            }
                                                                        } else {
                                                                            setPenPalSelected(penpalSelected.filter(email => email !== student.userEmail));
                                                                            setStudentsSelecte(studentsselected.filter(s => s.userEmail !== student.userEmail));
                                                                        }
                                                                    }} />
                                                                }
                                                                {
                                                                    !penpalSelected.includes(student.userEmail) && <MdCheckBoxOutlineBlank size={25} className={`xl:hidden text-[#8189B0]`} onClick={() => {
                                                                        if (!isSelected) {
                                                                            if (penpalSelected.length < 2) {
                                                                                setPenPalSelected([...penpalSelected, student.userEmail])
                                                                                setStudentsSelecte([...studentsselected, student])
                                                                            } else {
                                                                                handleClickOpen();
                                                                            }
                                                                        } else {
                                                                            setPenPalSelected(penpalSelected.filter(email => email !== student.userEmail));
                                                                            setStudentsSelecte(studentsselected.filter(s => s.userEmail !== student.userEmail));
                                                                        }
                                                                    }} />
                                                                }
                                                                <div className={`cursor-pointer ${penpalSelected.includes(student.userEmail) ? "border border-[#FAC236] bg-[#FAC236] bg-opacity-20 text-black" : "text-[#8189B0] border border-[#8189B0] bg-[#F1F6FB]"}  w-full py-[10px] flex justify-center items-center rounded-md mb-[10px]`}
                                                                    onClick={() => {
                                                                        if (!isSelected) {
                                                                            if (penpalSelected.length < 2) {
                                                                                setPenPalSelected([...penpalSelected, student.userEmail])
                                                                                setStudentsSelecte([...studentsselected, student])
                                                                            } else {
                                                                                handleClickOpen();
                                                                            }
                                                                        } else {
                                                                            setPenPalSelected(penpalSelected.filter(email => email !== student.userEmail));
                                                                            setStudentsSelecte(studentsselected.filter(s => s.userEmail !== student.userEmail));
                                                                        }
                                                                    }}
                                                                >

                                                                    <div className="flex flex-col items-center">
                                                                        <p className=" text-[17px] font-bold">{student.userFullName}</p>
                                                                        <p className=" text-[16px]">{student.userEmail}</p>
                                                                        <p className=" text-[16px]">{student.ethnicity}</p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </>
                                        :
                                        <div className="flex justify-center pt-[40px]">
                                            <p className="text-[15px] md:text-[20px] xl:text-[17px] text-black font-bold">{t('t285')}</p>
                                        </div>

                                }
                            </div>

                            {
                                filteredStudents.length > 0 &&
                                <div className="sticky bottom-0 pt-[5px] md:pt-[15px] pb-[5px] flex justify-center">
                                    <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center gap-[30px]">
                                        <button onClick={() => { handleClickNext(studentsselected) }} className="font-[600] xl:hidden w-[70%] bg-[#EFAE03] text-white px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md">
                                            {t('t7')}
                                        </button>
                                    </div>
                                </div>
                            }

                            {
                                errorNow &&
                                <div className="sticky bottom-0 flex justify-center">
                                    <p className={`text-red-600 ${i18n.language === "en" ? "text-[14px] md:text-[21px] lg:text-[24px]" : (i18n.language === "si" ? "text-[11px] md:text-[18px] lg:text-[20px]" : "text-[11px] md:text-[17px] lg:text-[19px]")}`}>
                                        {t('t284')}
                                    </p>
                                </div>
                            }


                        </div>

                        {/* desktop */}

                        <div className="pb-[120px] hidden xl:block">
                            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]`}>
                                <div className="flex items-center justify-between mt-[20px] lg:ml-[70px] w-full">
                                    <div className="flex items-center">
                                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                                            navigate('/desktop/researcher/dashboard')
                                        }} />
                                        <p className={`font-bold ml-[10px] ${i18n.language === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[20px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[17px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[17px] 2xl:text-[18px]")}`}>{t('t193')}</p>

                                    </div>
                                    <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center items-center">
                                        <button onClick={handleButtonClick} className="w-[45%] bg-transparent border border-[#EFAE03] border-[2px] text-[#EFAE03] font-bold px-[20px] py-[10px] md:py-[15px] xl:py-[10px] rounded-md">
                                            {t('t282')}
                                        </button>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            accept=".xlsx"
                                            onChange={handleFileChange}
                                            style={{ display: "none" }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 w-full px-[90px] gap-[50px]">
                                <div className="flex flex-col justify-center items-center border border-[#E0E8EE] rounded-xl mt-[20px] px-[20px] py-[20px]">
                                    <div className={`w-full flex items-centre justify-between ${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")}`}>
                                        <div className="flex flex-col items-start justify-center">
                                            <p className={`font-[600] ${i18n.language === "en" ? "xl:text-[18px] 2xl:text-[22px]" : (i18n.language === "si" ? "xl:text-[17px] 2xl:text-[18px]" : "xl:text-[17px] 2xl:text-[18px]")}`}>
                                                {t('t186')}</p>
                                            <p className={`text-start font-[500] text-[#4B5563] ${i18n.language === "en" ? "xl:text-[14px] 2xl:text-[28px]" : (i18n.language === "si" ? "xl:text-[11px] 2xl:text-[18px]" : "xl:text-[10px] 2xl:text-[18px]")}`}>
                                                {t('t460')}
                                            </p>
                                        </div>
                                        <input
                                            type="search"
                                            placeholder={t('t256')}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            value={searchInput}
                                            className={`w-[170px] px-[10px] py-[5px] border border-gray-300 rounded-md text-black ${i18n.language === "en" ? "xl:text-[14px] 2xl:text-[28px]" : (i18n.language === "si" ? "xl:text-[11px] 2xl:text-[18px]" : "xl:text-[10px] 2xl:text-[18px]")}`}
                                        />
                                    </div>
                                    <div className="mt-[20px] w-full ">

                                        {
                                            filteredStudents.length > 0 ?
                                                <>

                                                    <div className="max-h-[45vh] xl:max-h-[270px] 2xl:max-h-[550px] overflow-y-auto px-4 xl:grid grid-cols-2 xl:gap-[20px]">
                                                        {
                                                            filteredStudents.map((student, index) => {
                                                                const isSelected = penpalSelected.includes(student.userEmail);
                                                                return (
                                                                    <div key={index} className="flex justify-center items-center gap-[5px] md:gap-[20px]">
                                                                        {
                                                                            penpalSelected.includes(student.userEmail) && <MdCheckBox size={25} className={`xl:hidden text-[#EFAE03]`} onClick={() => {
                                                                                if (!isSelected) {
                                                                                    if (penpalSelected.length < 2) {
                                                                                        setPenPalSelected([...penpalSelected, student.userEmail])
                                                                                        setStudentsSelecte([...studentsselected, student])
                                                                                    } else {
                                                                                        handleClickOpen();
                                                                                    }
                                                                                } else {
                                                                                    setPenPalSelected(penpalSelected.filter(email => email !== student.userEmail));
                                                                                    setStudentsSelecte(studentsselected.filter(s => s.userEmail !== student.userEmail));
                                                                                }
                                                                            }} />
                                                                        }
                                                                        {
                                                                            !penpalSelected.includes(student.userEmail) && <MdCheckBoxOutlineBlank size={25} className={`xl:hidden text-[#8189B0]`} onClick={() => {
                                                                                if (!isSelected) {
                                                                                    if (penpalSelected.length < 2) {
                                                                                        setPenPalSelected([...penpalSelected, student.userEmail])
                                                                                        setStudentsSelecte([...studentsselected, student])
                                                                                    } else {
                                                                                        handleClickOpen();
                                                                                    }
                                                                                } else {
                                                                                    setPenPalSelected(penpalSelected.filter(email => email !== student.userEmail));
                                                                                    setStudentsSelecte(studentsselected.filter(s => s.userEmail !== student.userEmail));
                                                                                }
                                                                            }} />
                                                                        }
                                                                        <div className={`cursor-pointer ${penpalSelected.includes(student.userEmail) ? "border border-[#FAC236] bg-[#FAC236] bg-opacity-20 text-black" : "text-[#8189B0] border border-[#8189B0] bg-[#F1F6FB]"}  w-full py-[10px] flex justify-center items-center rounded-md mb-[10px]`}
                                                                            onClick={() => {
                                                                                if (!isSelected) {
                                                                                    if (penpalSelected.length < 2) {
                                                                                        setPenPalSelected([...penpalSelected, student.userEmail])
                                                                                        setStudentsSelecte([...studentsselected, student])
                                                                                    } else {
                                                                                        handleClickOpen();
                                                                                    }
                                                                                } else {
                                                                                    setPenPalSelected(penpalSelected.filter(email => email !== student.userEmail));
                                                                                    setStudentsSelecte(studentsselected.filter(s => s.userEmail !== student.userEmail));
                                                                                }
                                                                            }}
                                                                        >

                                                                            <div className="flex flex-col items-center">
                                                                                <p className=" text-[17px] font-bold text-black">{student.userFullName}</p>
                                                                                <p className=" text-[16px] text-[#4B5563]">{student.userEmail}</p>
                                                                                <p className=" text-[16px] text-[#4B5563]">{student.ethnicity}</p>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <div className="flex justify-center pt-[40px]">
                                                    <p className="text-[15px] md:text-[20px] xl:text-[17px] text-black font-bold">{t('t285')}</p>
                                                </div>

                                        }
                                    </div>
                                </div>
                                <div className="flex flex-col justify-start items-center border border-[#E0E8EE] rounded-xl mt-[20px] px-[20px] py-[20px]">


                                    <div className="mt-[20px] w-full ">

                                        {
                                            studentsselected.length > 0 ?
                                                <>

                                                    <div className="max-h-[45vh] xl:max-h-[270px] 2xl:max-h-[550px] overflow-y-auto px-4 xl:grid grid-cols-2 xl:gap-[20px]">
                                                        {
                                                            studentsselected.map((student, index) => {
                                                                return (
                                                                    <div key={index} className="flex justify-center items-center gap-[5px] md:gap-[20px]">
                                                                        <div className={`cursor-pointer ${penpalSelected.includes(student.userEmail) ? "border border-[#FAC236] bg-[#FAC236] bg-opacity-20 text-black" : "text-[#8189B0] border border-[#8189B0] bg-[#F1F6FB]"}  w-full py-[10px] flex justify-center items-center rounded-md mb-[10px]`}>

                                                                            <div className="flex flex-col items-center">
                                                                                <p className=" text-[17px] font-bold text-black">{student.userFullName}</p>
                                                                                <p className=" text-[16px] text-[#4B5563]">{student.userEmail}</p>
                                                                                <p className=" text-[16px] text-[#4B5563]">{student.ethnicity}</p>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <div className="flex justify-center pt-[40px]">
                                                    <p className="text-[15px] md:text-[20px] xl:text-[17px] text-black font-bold">{t('t284')}</p>
                                                </div>

                                        }
                                    </div>
                                    {
                                        studentsselected.length > 1 &&
                                        <div className="flex flex-col items-center justify-center mt-[20px]">
                                            <p className={`text-start font-[500] ml-[10px] text-[#4B5563] mt-[5px] ${i18n.language === "en" ? "xl:text-[17px] 2xl:text-[18px]" : (i18n.language === "si" ? "xl:text-[14px] 2xl:text-[15px]" : "xl:text-[14px] 2xl:text-[15px]")}`}>
                                                {t('t461')}
                                            </p>
                                            <div className="hidden xl:flex justify-center gap-[15px] md:gap-[30px] items-center  w-full xl:pt-[10px] mt-[20px]">
                                                {/* <div onClick={() => setIsControlSelected(true)} className={`cursor-pointer  ${isControlSelected !== null && isControlSelected ? 'bg-[#FDC50C]' : 'bg-[#D9D9D9]'} rounded-2xl w-[160px] md:w-[180px] flex justify-center`}>
                                                    <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t212')}</p>
                                                </div>
                                                <div onClick={() => setIsControlSelected(false)} className={`cursor-pointer  ${isControlSelected !== null && !isControlSelected ? 'bg-[#FDC50C]' : 'bg-[#D9D9D9]'} rounded-2xl w-[160px] md:w-[180px] flex justify-center`}>
                                                    <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t213')}</p>
                                                </div> */}

                                                <button onClick={() => { setIsControlSelected(false) }} className={`font-[600] min-w-[200px] ${isControlSelected !== null && !isControlSelected && "bg-opacity-40"} bg-[#0E141F] text-white px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md`}>
                                                    Treat
                                                </button>
                                                <button onClick={() => { setIsControlSelected(true) }} className={`font-[600] min-w-[200px] ${isControlSelected !== null && isControlSelected && "bg-opacity-40"} bg-[#0E141F] text-white px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md`}>
                                                    Control
                                                </button>
                                            </div>
                                        </div>
                                    }

                                </div>


                            </div>

                            {
                                studentsselected.length > 1 && isControlSelected !== null &&
                                <div className="sticky bottom-0 py-4 flex justify-end mx-[90px] mt-[20px]">
                                    <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-end ">
                                        <button onClick={handleClick} className="hidden xl:block w-[45%] bg-[#F2AC0E] text-white font-bold px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md">
                                            {t('t283')}
                                        </button>
                                    </div>
                                </div>
                            }
                            {
                                !errorNow && errorGrp &&
                                <div className="sticky bottom-0 flex justify-center">
                                    <p className="text-red-600 text-[15px]">
                                        {t('t419')}
                                    </p>
                                </div>
                            }
                            {
                                errorNow &&
                                <div className="sticky bottom-0 flex justify-center">
                                    <p className="text-red-600 text-[15px]">
                                        {t('t284')}
                                    </p>
                                </div>
                            }


                        </div>
                    </div>
            }



            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        The excel sheet uploaded successfully.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose1}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openAlert}
                onClose={handleCloseAlert}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    Incorrect format
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <p>Please make sure the document format is corresponding with the following and try again.</p>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className="pt-[20px]">
                        <li>First column should be student email</li>
                        <li>Second column should be penpal's email</li>
                        <li> Third column should be the group(either CONTROL or TREATMENT)</li>
                        <li> Sheet shouldn't have column names.</li>
                    </ul>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseAlert}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={openInfo}
                onClose={handleCloseInfo}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t462')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    {/* <p>{t('t462')}</p> */}
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className="pt-[20px]">
                        <li>{t('t463')}</li>
                        <li>{t('t464')}</li>
                        <li> {t('t466')}</li>
                        <li> {t('t465')}</li>
                    </ul>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={() => setOpenInfo(false)}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                    <Button
                        onClick={handleCloseInfo}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default ResearcherPenpalMatchingManual;
